import { missionPEOField } from '../../../../utils/constants'

export const initialState = (page_element = {}) => ({
  id: page_element.id,
  page_element_options: page_element.page_element_options.map(peo => ({
    id: peo.id,
    selected: false,
    attempts: [],
  })),
})

export const answerUpdate = (state = initialState(), payload, attempt) => ({
  ...state,
  page_element_options: state.page_element_options.map((peo) => {
    const selected = payload[missionPEOField(state, peo)] || false
    return {
      ...peo,
      selected,
      attempts: (selected && attempt && (peo.attempts.indexOf(attempt) === -1))
        ? peo.attempts.concat(attempt)
        : peo.attempts,
    }
  }),
})



// WEBPACK FOOTER //
// ./src/reducers/Missions/Answers/Form/checkbox.jsx